// extracted by mini-css-extract-plugin
export default {"wrap_menu":"Menu_wrap_menu__UpgWB","wrap_menu__container":"Menu_wrap_menu__container__fdWov"};